import * as React from 'react';
import { useFocused, useSelected, useSlateStatic } from 'slate-react';
import styled from 'styled-components';

import { BaseBulletPointPluginProps } from '../BulletPointPlugin.types';
import { ListSwitcherPopOver } from '../components/ListSwitcherPopOver';
import { SharedListStyle } from './ListStyle';

const Main = styled.ul`
  ${SharedListStyle}
`;

export const useCheckListIsFirstChild = (ref) => {
  const [isFirstChild, setIsFirstChild] = React.useState(false);

  React.useEffect(() => {
    if (ref?.current) {
      setIsFirstChild(
        ['LI', 'UL', 'P'].includes(ref.current.parentNode.parentNode.tagName) === false
      );
    }
  }, [ref]);
  return isFirstChild;
};

interface UnorderedListElementProps extends BaseBulletPointPluginProps {}

export const UnorderedListElementEditable = (props: UnorderedListElementProps) => {
  const { children, attributes, isReadOnly } = props;
  const selected = useSelected();
  const focused = useFocused();
  const editor = useSlateStatic();
  const ref = React.useRef();
  const isFirstChild = useCheckListIsFirstChild(ref);

  const isPopoverVisible = isFirstChild && !isReadOnly && focused && selected && editor.selection;
  return (
    <Main {...attributes} className="unordered-list-element">
      {children}
      <div ref={ref} />
      {isPopoverVisible && <ListSwitcherPopOver />}
    </Main>
  );
};

export const UnorderedListElementReadOnly = (props: UnorderedListElementProps) => {
  const { children, attributes } = props;

  return <ul {...attributes}>{children}</ul>;
};
